import { Tag, baseApi } from './base'

import { cacher } from '@/utils/rtkQueryCacheUtils'

export type Permission = {
  action: string[]
  resource: string[]
}

export type Policy = {
  _id: string
  createdBy?: string
  name: string
  description: string
  permissions: Permission[]
  type: 'system' | 'artificial'
}

export type CreatePolicyParams = {
  name: string
  description?: string
  permissions: Permission[]
}

export type UpdatePolicyParams = Partial<CreatePolicyParams>

export const policyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPolicy: builder.query<Policy, string>({
      query: (policyId) => ({
        url: `/policies/${policyId}`,
        method: 'GET',
      }),
    }),
    getPolicies: builder.query<Policy[], void>({
      query: () => ({
        url: `/policies`,
        method: 'GET',
      }),
      providesTags: cacher.providesList(Tag.POLICY),
    }),
    createPolicy: builder.mutation<Policy, CreatePolicyParams>({
      query: (body) => ({
        url: '/policies',
        method: 'POST',
        body,
      }),
      invalidatesTags: cacher.invalidatesList(Tag.POLICY),
    }),
    updatePolicy: builder.mutation<Policy, UpdatePolicyParams & { id: string }>({
      query: ({ id, ...body }) => ({
        url: `/policies/${id}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedPolicy } = await queryFulfilled
          dispatch(
            policyApi.util.updateQueryData('getPolicy', id, (draftPolicy) => {
              Object.assign(draftPolicy, updatedPolicy)
            })
          )
        } catch (error) {
          console.log(error)
        }
      },
    }),
    deletePolicy: builder.mutation<Policy, string>({
      query: (policyId) => ({
        url: `/policies/${policyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: cacher.invalidatesList(Tag.POLICY),
    }),
  }),
  overrideExisting: false,
})
